import $ from 'jquery'

import {addAnimation} from "./observers/animations";

let animating = false;
const sum = 'section.summary';


function initSummary() {
    if ($(sum).length !== 0) {
        //console.log('summary present');
        addAnimation(sum, 'idle', 'pub:animation:callback:summary');
        $(window).on('load', function () {
            setListeners()
            // toggleSummary() // SHOW DIRECTLY!
            $(sum).addClass('pasive')
            $(sum).addClass('loaded')
        });
    }
}

function setListeners() {

    $('.hud_button').on('click', function (event) {
        toggleSummary(event)
    });

    $(document).on('pub:animation:callback:summary', function (e, ani) {
        // //console.log('callback SUCCES! ' + ani);
        animating = false;
        $(ani).removeClass('animating');

        if (!$(sum).addClass('loaded')) {
            $(sum).addClass('loaded')
        }
        if (!$(sum).hasClass('show')) {
            if (!$(sum).hasClass('pasive')) {
                $(sum).addClass('pasive')
            }
        }
    });
}

function toggleSummary() {
    if (!animating) {
        animating = true;

        if ($(sum).hasClass('pasive')) {
            $(sum).removeClass('pasive')
            $(sum).toggleClass('show')
            $('body').toggleClass('locked')
            $('.hud .nav-icon-hamburger').toggleClass('open')
            $('body').toggleClass('summary-active')
        } else if ($(sum).hasClass('show')) {
            $(sum).toggleClass('show')
            $('body').toggleClass('locked')
            $('.hud .nav-icon-hamburger').toggleClass('open')
            $('body').toggleClass('summary-active')
        }
    }
}

export default initSummary;


